{
  "pages": {
    "BalanceActivity": {
      "balance_activity": "Balance activity",
      "export": "Export",
      "attrs": {
        "search_by_transaction_id_payout_id": "Search by transaction ID, payout ID, order ref, dispute ref"
      },
      "all_balances": "All balances",
      "available": "Available",
      "incoming": "Incoming",
      "reserved": "Reserved",
      "on_hold": "On hold",
      "all_activity": "All activity",
      "payment": "Payment",
      "refund": "Refund",
      "payout": "Payout",
      "fee": "Fee",
      "reserve_hold": "Reserve hold",
      "review_hold": "Review hold",
      "last_30_days": "Last 30 days",
      "last_7_days": "Last 7 days",
      "last_90_days": "Last 90 days",
      "this_month": "This month",
      "last_month": "Last month",
      "effective_date": "Effective date",
      "balance_type": "Balance type",
      "activity_type": "Activity type",
      "description": "Description",
      "reference": "Reference",
      "amount_change": "Amount change",
      "running_balance": "Running balance",
      "usd": "MVR",
      "showing": "Showing",
      "to": "to",
      "of": "of",
      "entries": "entries",
      "previous": "Previous",
      "next": "Next"
    },
    "balanceTypes": {
      "reserve_policy": "Reserve policy:",
      "10_of_each_payment_is_held": "10% of each payment is held for 90 days as a safeguard against\n            chargebacks and disputes. Funds are automatically released to your\n            available balance after the holding period."
    },
    "CustomTooltip": {
      "available_usd": "Available : MVR"
    },
    "BalanceSummary": {
      "simulate_negative_balance": "Simulate negative balance",
      "set_a_minimum_to_avoid_negative": "Set a minimum to avoid negative balances",
      "your_account_has_a_negative_balance": "Your account has a negative balance due to refunds, disputes,\n                reserves, or fees. We'll debit your account to cover the\n                difference. Set a minimum to prevent negative balances.",
      "set_minimum_balance": "Set minimum balance",
      "minimum_balance_set_to_usd": "Minimum balance set to MVR",
      "well_automatically_top_up_your_account": "We'll automatically top up your account when it drops below this\n                threshold.",
      "available_balance": "Available balance",
      "the_sum_of_your_available_payments": "The sum of your available payments balances converted to your\n                default currency.",
      "balance_summary": "Balance summary",
      "amount": "Amount",
      "no_upcoming_payouts": "No upcoming payouts",
      "your_account_has_a_negative_balance_2": "Your account has a negative balance. Payouts are\n                              paused until the balance is restored. Add funds or\n                              set a minimum balance to resume payouts.",
      "txns": "txns",
      "transaction": "Transaction",
      "customer": "Customer",
      "view_all_activity": "View all activity",
      "total_balance": "Total balance",
      "usd_8296725": "MVR 82,967.25",
      "when_your_balance_drops_below_this": "When your balance drops below this amount, we'll notify you\n                  and can automatically top up from your linked bank account.",
      "minimum_balance_usd": "Minimum balance (MVR)",
      "attrs": {
        "eg_5000": "e.g., 5,000"
      },
      "your_current_balance_is": "Your current balance is",
      "in_deficit_setting_a_minimum_will": "in deficit. Setting a minimum will help prevent this in\n                      the future.",
      "cancel": "Cancel",
      "save_minimum": "Save minimum"
    },
    "PayoutSettings": {
      "attrs": {
        "back_to_settings": "Back to settings",
        "thailand": "Maldives"
      },
      "payout_settings": "Payout settings",
      "settlement_currencies_and_bank_accounts": "Settlement currencies and bank accounts",
      "to_accumulate_a_balance_in_a": "To accumulate a balance in a new currency, add it here. Attach a\n              bank account to pay out the balance.",
      "currency": "Currency",
      "payout_bank_account": "Payout bank account",
      "payout_fee": "Payout fee",
      "default": "Default",
      "kasikorn_bank": "BANK OF MALDIVES",
      "free": "FREE",
      "edit": "Edit",
      "add_a_settlement_currency": "Add a settlement currency",
      "minimum_balance": "Minimum balance",
      "keep_a_minimum_amount_in_your": "Keep a minimum amount in your balance so that funds are available\n              in case of refunds, disputes, and fees.",
      "keep_a_minimum_amount_in_your_2": "Keep a minimum amount in your payments balance",
      "we_will_adjust_your_payouts_so": "We will adjust your payouts so that you maintain a minimum\n                  balance.",
      "the_amount_must_be_greater_than": "The amount must be greater than 0.",
      "add_another_currency": "Add another currency",
      "save": "Save",
      "payout_statement_descriptor": "Payout statement descriptor",
      "select_a_statement_descriptor_for_payouts": "Select a statement descriptor for payouts that appear on your bank\n              statement.",
      "you_can_set_a_custom_statement": "You can set a custom statement descriptor when manually creating\n                a payout from",
      "balances": "Balances",
      "overriding_this_accountlevel_setting": ", overriding this account-level setting.",
      "statement_descriptor": "Statement Descriptor"
    },
    "Payouts": {
      "payouts": "Payouts",
      "payouts_nov_30_dec_6_2025": "payouts · May 1 – May 7, 2026",
      "payouts_nov_7_dec_6_2025": "payouts · Apr 8 – May 7, 2026",
      "merchant_entity": "Merchant entity",
      "payout_id": "Payout ID",
      "payout_status": "Payout status",
      "payout_effective_date": "Payout effective date",
      "gross_amount": "Gross amount",
      "total_deductions": "Total deductions",
      "net_amount": "Net amount",
      "destination_account": "Destination account",
      "external_payout_reference": "External payout reference",
      "report": "Report",
      "csv": ".csv"
    }
  }
}
